import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useState } from "react";
import background from "../../../Utils/Images/background.png";
import { Link, useNavigate } from "react-router-dom";
import CustomInput from "../../../Components/input/CustomInput";
import CustomButton from "../../../Components/Button/CustomButton";
import PasswordInput from "../../../Components/input/PasswordInput";
import { API_POST } from "../../../APIs/Config";
import { API } from "../../../APIs/Config";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      email: "",
    }));
  };

  const HandlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setLoading(false);
      return "Email is required";
    }
    if (!emailRegex.test(email)) {
      setLoading(false);
      return "Invalid email format";
    }
    return "";
  };

  const handleSubmit = async () => {
    setLoading(true);
    const emailError = validateEmail();
    setErrors({
      email: emailError,
    });
    if (!emailError) {
      const f = new FormData();
      f.append("email", email);
      f.append("password", password);
      try {
        const data = await API_POST(API.login, f);
        console.log(data);
        setLoading(false);
        if (data && data?.s) {
          const privilegesArray = data?.r.privileges.split(",").map(Number);
          localStorage.setItem(
            "privillegesArray",
            JSON.stringify(privilegesArray)
          );
          localStorage.setItem("role", data?.r.role);
          localStorage.setItem("apikey", data?.r.apikey);
          localStorage.setItem("token", data?.r.token);
          navigate("/");
        } else {
          setLoading(false);
          alert(data.m);
          console.error("Login failed:");
        }
      } catch (error) {
        // Handle login error
        alert("wrong credentials");
        setLoading(false);
        console.error("Login failed:", error);
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          objectFit: "cover",
          fill: "Background",
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "cover",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "70%", sm: "60%", md: "40%", xl: "25%" },
            padding: { xs: "20px", md: "35px", xl: "45px" },
            borderRadius: "10px",
            bgcolor: "#F3F3F3",
            m: "auto",
            boxShadow: "10px 10px 26px 0px #0000001A",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: { xs: "20px", md: "22px", xl: "25px" },
              fontWeight: "600",
              lineHeight: "25px",
              textAlign: "left",
            }}
          >
            Welcome Back, Admin 👋🏼
          </Typography>
          <Box
            sx={{
              width: "273px",
              textAlign: "left",
              mt: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "inter",
                fontSize: { xs: "14px", md: "15px", xl: "16px" },
                fontWeight: "400",
                lineHeight: "22.4px",
                textAlign: "left",
                color: "#737373",
              }}
            >
              Welcome Back Please <br /> Enter Your Login Details
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: "10px",
            }}
          >
            <CustomInput
              variant="outlined"
              // onChange={handleEmail}
              placeholder="Email Address"
              onChange={handleEmailChange}
              error={Boolean(errors.email)}
              helperText={errors.email}
              sx={{
                mt: "5px",
                textAlign: "center",
                bgcolor: "white",
                borderRadius: "5px",
                fontSize: { xs: "8px", md: "10px", xl: "34px" },
              }}
            />
            <PasswordInput HandlePasswordChange={HandlePasswordChange} />
          </Box>
          <Box
            sx={{
              justifyContent: "flex-end",
              display: "flex",
              width: "100%",
            }}
          >
            <Link
              style={{ textDecoration: "none", color: "#000000" }}
              to={"/forgot"}
            >
              <Typography
                sx={{
                  color: "#000000",
                  fontFamily: "inter",
                  fontSize: { xs: "12px", md: "15px", xl: "16px" },
                  fontWeight: "400",
                  lineHeight: "22.4x",
                  alignItems: "center",
                  mt: "20px",
                }}
              >
                Forgot Password ?
              </Typography>
            </Link>
          </Box>
          <CustomButton
            // disabled={loading}
            sx={{
              mt: "20px",
              height: { xs: "25px", md: "40px", xl: "60px" },
            }}
            onClick={handleSubmit}
          >
            {loading ? (
              <CircularProgress
                sx={{
                  height: { xs: "20px", md: "30px", xl: "40px" },
                  width: { xs: "20px", md: "30px", xl: "40px" },
                }}
                color="inherit"
              />
            ) : (
              "Login"
            )}
          </CustomButton>
        </Box>
      </Box>
    </>
  );
};

export default Login;
